import React, { Component } from 'react';
import { browserHistory } from 'react-router'
import EllipsisText  from 'react-ellipsis-text';
import ReactMarkdown from 'react-markdown';

import {} from './NewsHome.css';

import News from '../data/newsjson';

class NewsHome extends Component {
    constructor(props) {
        super(props);
        document.title = "g-C3N4 News";
        this.state = {
            loaded: false,
            news: this.setNewsArticles(News.articlelist)
        };
        
        this.state = {
            loaded: true,
            news: this.state.news
        };
    
    }

    showArticle(item, e){
        e.preventDefault();
        browserHistory.push({ //browserHistory.push should also work here
            pathname: 'news/article',
            state: {item: item}
          }); 
    }

    setNewsArticles(articlelist) {
        return (
            articlelist.map(item =>
                <div className="News-container" key={item.id} onClick={this.showArticle.bind(this, item)}>
                    <div className="News-header" >
                        <EllipsisText className="News-header-text"  text={item.title} length={100} />
                    </div>
                    <div className="News-detail">
                        <img className="News-detail-image" src={item.image} alt="g-C3N4 News" />
                        <div className="News-detail-article">
                            <ReactMarkdown className="DisplayLinebreak" source={item.article.substring(0,200) + '...'} />
                            {/* <EllipsisText className="News-detail-article-text" text={item.article} length={200} /> */}
                        </div>
                    </div>
                </div>
                )
            )
    }

    render() {
        if (this.state.loaded) {
            return (
                <div className="container">
                    <p className="title">News </p>
                    <p className="subtitle">The news articles we've found from around the world </p>
                    <p>The content we've put up can be viewed off line if you've visited before, but please do visit the original article for the full experience if you are connected.</p>
                    {this.state.news} 
                </div>
            );
        } else {
            return (
                <div>
                    Loading...
                </div>
            )
        }
    }
}

export default NewsHome;


// WEBPACK FOOTER //
// ./src/News/NewsHome.js